import axios from 'axios';
import { getAuthHeaders } from '../utils/auth';
import { API_URL } from '../constants/urls';

export interface Segment {
  id: string;
  organization_id: string;
  name: string;
  description?: string;
  focus_mode?: string;
  priority?: string;
  strategic_owner_id?: string;
  display_order: number;
  group_name?: string;
  group_id?: string;
}

export const segmentService = {
  async list(organizationId: string): Promise<Segment[]> {
    const response = await axios.get(
      `${API_URL}/segments?organization_id=${organizationId}`,
      {
        headers: getAuthHeaders(),
      },
    );
    return response.data;
  },

  async get(organizationId: string, segmentId: string): Promise<Segment> {
    const response = await axios.get(
      `${API_URL}/segments/${segmentId}?organization_id=${organizationId}`,
      {
        headers: getAuthHeaders(),
      },
    );
    return response.data;
  },
};
